export default __webpack_public_path__ + "static/media/open.55e39207.svg";